import { RootState } from 'redux/store';

export const selectSettingParams = (state: RootState) => state.sorting.settingParams;

export const selectSortingArray = (state: RootState) => state.sorting.sortingArray;

export const selectTimer = (state: RootState) => state.sorting.timer;
